import { Link } from 'react-router-dom'
import { Calendar, ArrowRight } from 'lucide-react'
import type { NewsItem } from '../../model/types'

export function NewsCard({ item }: { item: NewsItem }) {
  return (
    <article className="bg-surface border border-border rounded-xl overflow-hidden shadow-card hover:shadow-hover transition group">
      <Link to={item.to} className="block aspect-[16/9] bg-slate-100 overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          loading="lazy"
          className="w-full h-full object-contain p-4"
          onError={(e) => {
            (e.target as HTMLImageElement).src =
              'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9"><rect width="16" height="9" fill="%23e2e8f0"/></svg>'
          }}
        />
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-1.5 text-xs text-muted mb-2">
          <Calendar className="w-3.5 h-3.5" />
          <span>{item.date}</span>
        </div>
        <Link to={item.to} className="block font-semibold text-text hover:text-brand-600 transition line-clamp-2 min-h-[48px]">
          {item.title}
        </Link>
        <p className="text-sm text-muted mt-2 line-clamp-2">{item.excerpt}</p>
        <Link to={item.to} className="mt-3 inline-flex items-center gap-1 text-sm text-brand-600 font-medium hover:underline">
          Đọc tiếp <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  )
}
